import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../lib/api';
import Button from '../../components/ui/Button';

const STORAGE_KEY = 'kol_instagram_oauth_profile_id';

export function rememberKolProfileForInstagramOAuth(kolProfileId: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, kolProfileId);
  } catch {
    /* ignore */
  }
}

export default function InstagramCallback() {
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('Completing Instagram connection…');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    const code = search.get('code');
    const state = search.get('state');
    const err = search.get('error');
    const errDesc = search.get('error_description');
    let kolProfileId = '';
    try {
      kolProfileId = sessionStorage.getItem(STORAGE_KEY) || '';
    } catch {
      kolProfileId = '';
    }

    if (err) {
      setMessage(errDesc || err || 'Instagram authorization was cancelled.');
      return;
    }
    if (!code || !state) {
      setMessage('Missing authorization code. Try connecting again from your profile.');
      return;
    }
    if (!kolProfileId) {
      setMessage('Session expired. Open your profile and start Instagram connect again.');
      return;
    }

    ran.current = true;
    (async () => {
      try {
        await api.post('/kols/me/instagram/complete', { code, state, kolProfileId });
        try {
          sessionStorage.removeItem(STORAGE_KEY);
        } catch {
          /* ignore */
        }
        navigate('/kol/my-profile?instagram=connected&step=2', { replace: true });
      } catch (e: unknown) {
        const ax = e as { response?: { data?: { error?: string } } };
        setMessage(ax.response?.data?.error || 'Could not complete Instagram connection.');
      }
    })();
  }, [navigate, search]);

  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center gap-4 px-4 text-center">
      <p className="text-glass-text max-w-md">{message}</p>
      <Button variant="outline" onClick={() => navigate('/kol/my-profile', { replace: true })}>
        Back to profile
      </Button>
    </div>
  );
}
